import React from 'react'
import PropTypes from 'prop-types'

import FormField from 'components/forms/FormField'
import Grid from 'suitTheme/Grid'
import SidebarModal from 'modals/sidebar/SidebarModal'

import Thumbnail from '../Thumbnail'

const SpecifiedImages = (props) => {
  const {
    callbacks: { selectImage }, specifiedImages, tileSize, viewMode,
  } = props

  return (
    <>
      <FormField direction="column" label="Specified Images">
        <Grid
          gridGap="medium"
          gridAutoRows="1fr"
          gridTemplateColumns={`repeat(auto-fill, minmax(${tileSize.width}px, 1fr))`}
          gridTemplateRows={`repeat(auto-fill, minmax(${tileSize.height}px, 1fr))`}
        >
          {specifiedImages.map(image => (
            <Thumbnail callbacks={{ selectImage }} key={image.id} image={image} viewMode={viewMode} />
          ))}
        </Grid>
      </FormField>

      <SidebarModal.Separator boxProps={{ marginY: 'large' }} />
    </>
  )
}

SpecifiedImages.propTypes = {
  callbacks: PropTypes.shape({
    selectImage: PropTypes.func.isRequired,
  }).isRequired,
  specifiedImages: PropTypes.array.isRequired,
  tileSize: PropTypes.object.isRequired,
  viewMode: PropTypes.string.isRequired,
}

export default SpecifiedImages
